import 'vue';
import FavoriteManagerApp from '@vue/app/FavoriteManagerApp.vue';
import { createApp } from 'vue';
import { createBootstrap } from 'bootstrap-vue-next';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
await S.import('@main');
await u.domready();
const app = createApp(FavoriteManagerApp);
app.use(createBootstrap());
app.mount('favorite-manager-app');
u.directive('favorite-button', {
    mounted(el, { value }) {
        el.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            u.trigger('open.fav.collections', el, value);
        });
    }
});
